import * as React from 'react'

import ApiKeysContainer from '../../containers/api-keys/api-keys'
import WebhooksContainer from '../../containers/webhooks/webhooks'
import { NavTabs } from '@yuno/design-system-web'
import {
  BannerImage,
  BannerText,
  Close,
  TitleStyled,
  WrapperTitle,
} from './style'
import WrapperLayout from '../../layouts/wrapper-layout'
import { constants } from '../../utils/constants'
import { useTranslation } from 'react-i18next'

const DOCS_URL = constants.DOCS_URL

const DevelopersPage = () => {
  const isEnableBanner =
    JSON.parse(localStorage.getItem('UI_CONFIG'))?.developersBanner !== 'OFF'

  const { t } = useTranslation()

  const [showBanner, setShowBanner] = React.useState<boolean>(isEnableBanner)

  // Se comenta para luego ser fixeada esta llamada
  /* const { webhooks, isLoading } = useWebhooks()
  const webhookIconElement =
    webhooks.length > 0 ? <CounterSpan>{webhooks.length}</CounterSpan> : null */

  const tabs = [
    {
      label: t('tabApiKey'),
      content: <ApiKeysContainer />,
    },
    {
      label: t('webhooks'),
      // elementIcon: webhookIconElement,
      content: <WebhooksContainer />,
    },
  ]

  const handleClose = () => {
    setShowBanner(false)
    localStorage.setItem(
      'UI_CONFIG',
      JSON.stringify({
        developersBanner: 'OFF',
      }),
    )
  }

  return (
    <>
      {showBanner && (
        <WrapperLayout>
          <BannerImage>
            <BannerText type={'title'}>{t('prepareIntegrate')}</BannerText>
            <BannerText type={'body'}>{t('emailYunoFeedbackOne')}</BannerText>
            <BannerText type={'body'}>
              {t('emailYunoFeedbackTwo')}
              <a href="mailto://support@y.uno">{t('emailYunoFeedbackLink')}</a>
              {t('emailYunoFeedbackFinal')}
            </BannerText>
            <BannerText type={'body'} marginTop={'8px'}>
              <a href={DOCS_URL} target={'_blank'} className="doc-link">
                {t('apiReference')}
              </a>
            </BannerText>
            <Close onClick={handleClose} />
          </BannerImage>
        </WrapperLayout>
      )}
      <WrapperTitle>
        <TitleStyled>{t('developers')}</TitleStyled>
      </WrapperTitle>
      <NavTabs tabs={tabs} tabsMarginLeft={20} />
    </>
  )
}

export default DevelopersPage
